import React from 'react'

const Tr = (props) => {

    const sales = props.sales;

    return (
    <>
        <tr>
            <td>{sales.month}/{sales.day}</td>
            <td>{ (Number(sales.total_cash_sales_cny || 0) - Number(sales.total_cash_refund_cny || 0))
                .toLocaleString('ja-JP', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} 元</td>
            <td>¥{ Math.round((Number(sales.total_cash_sales_cny || 0) - Number(sales.total_cash_refund_cny || 0)) / (props.rate || 0.043)).toLocaleString('ja-JP') }</td>
            <td>{Number(sales.total_card_exchange_point || 0).toLocaleString('ja-JP')} pt</td>
            <td>{Number(sales.total_use_points).toLocaleString('ja-JP')} pt</td>
            <td>{Number(sales.total_give_points).toLocaleString('ja-JP')} pt</td>
            <td>{Number(sales.total_shop_payment_points).toLocaleString('ja-JP')} pt</td>
            <td>{Number(sales.total_user_total_point).toLocaleString('ja-JP')} pt</td>
            <td>{Number(sales.total_user_count).toLocaleString('ja-JP')}</td>
        </tr>
    </>
    )
}

export default Tr